import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

const POST_INSERT_MODEL = '/warranty/abm/api/v2/admin/options/mobile-models/update/status';

export const useEditModel = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (formData) => {
      const response = await POST(POST_INSERT_MODEL, formData);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'แก้ไข Model สำเร็จ',
      });
    },
  });
};
